// ═══════════════════════════════════════════════════════════════
// CoupleNode.js — Nœud virtuel « couple parental » (Family P2c)
// ═══════════════════════════════════════════════════════════════
// Nœud visuel intermédiaire : représente un couple conjoint qui
// partage au moins un enfant. Les deux conjoints pointent chacun
// un trait discret vers ce nœud ; les enfants reçoivent ensuite
// un seul trait descendant depuis le couple.
// Pas persisté en DB — calculé à la volée côté client.
// ═══════════════════════════════════════════════════════════════

import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { Heart } from 'lucide-react';

const CoupleNode = ({ data }) => {
    const { isDark, color = '#1D4ED8' } = data;
    return (
        <div
            style={{
                width: 28,
                height: 28,
                borderRadius: '50%',
                background: isDark ? '#1a1a2e' : '#ffffff',
                border: `2px solid ${color}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: `0 2px 10px ${color}33`,
            }}
            title="Couple parental"
        >
            <Handle type="target" position={Position.Top} id="t" style={{ opacity: 0, pointerEvents: 'none' }} />
            <Handle type="target" position={Position.Left} id="tl" style={{ opacity: 0, pointerEvents: 'none', top: '50%' }} />
            <Handle type="target" position={Position.Right} id="tr" style={{ opacity: 0, pointerEvents: 'none', top: '50%' }} />
            <Heart size={12} strokeWidth={2.4} style={{ color }} />
            <Handle type="source" position={Position.Bottom} id="s" style={{ opacity: 0, pointerEvents: 'none' }} />
        </div>
    );
};

export default CoupleNode;
